import React from "react";
import Skeleton from "react-loading-skeleton";
import { View } from "react-native";
import { DEVICE_SIZES, useDeviceSize } from "rn-responsive-styles";
import Skeletons from "./Skeletons";
import { AppColors } from "../../utility/AppColors";
import { s } from "react-native-size-matters";

const ChooseGameLikeSkeleton = () => {
  const deviceSize = useDeviceSize();
  let skeletonCards = Array(2).fill(0);
  let gameCards = Array(12).fill(0);
  return (
    <View
      style={{
        paddingHorizontal:
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? s(10)
            : s(44),
        paddingTop: s(44),
        flex: 1,
        justifyContent: "space-between",
      }}
    >
      <Skeletons
        height={49}
        width={
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "80%"
            : "26%"
        }
        style={{
          borderRadius: 10,
          marginTop: 6,
        }}
      />
      <Skeletons
        height={20}
        width={
          deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
            ? "50%"
            : "15%"
        }
        style={{
          borderRadius: 10,
          marginTop: 6,
        }}
      />
      <View
        style={{
          flexDirection: "row",
          width: "50%",
          gap: 30,
          alignItems: "center",
        }}
      >
        <Skeletons
          height={45}
          width={
            deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
              ? "220px"
              : "462px"
          }
          style={{
            borderRadius: 10,
            marginTop: 6,
          }}
        />

        <Skeletons
          height={30}
          width={"97px"}
          style={{
            borderRadius: 10,
            marginTop: 6,
          }}
        />
      </View>
      {skeletonCards.map((index) => (
        <View>
          <Skeletons
            height={20}
            width={
              deviceSize === DEVICE_SIZES.XS || deviceSize === DEVICE_SIZES.SM
                ? "30%"
                : "10%"
            }
            style={{
              borderRadius: 10,
              marginTop: 6,
            }}
          />
          <View
            style={{
              flexDirection: "row",
              gap: 6.78,
            }}
          >
            {gameCards.map((index) => (
              <View
                style={{
                  flexDirection: "column",
                  gap: 6.78,
                }}
              >
                <Skeletons
                  height={128}
                  width={"110px"}
                  style={{
                    borderRadius: 10,
                    marginTop: 6,
                  }}
                />
                <Skeletons
                  height={20}
                  width={"55%"}
                  style={{
                    borderRadius: 10,
                    marginTop: 6,
                  }}
                />
              </View>
            ))}
          </View>
        </View>
      ))}
      <View
        style={{
          flexDirection: "row",
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Skeletons
          height={35}
          width={"97px"}
          style={{
            borderRadius: 40,
            marginTop: 6,
            marginBottom: 10,
          }}
        />
        <Skeletons
          height={35}
          width={"130px"}
          style={{
            borderRadius: 40,
            marginTop: 6,
            marginBottom: 10,
          }}
        />
      </View>
    </View>
  );
};

export default ChooseGameLikeSkeleton;
